import { Link } from "react-router";
import logoFooterDTA from "@assets/events-awards/dta/logo-footer-dta.png";
import { DTA_FOOTER_MENU } from "@dta/utils/constants";
import FooterMenuLinks from "@events-awards/components/EventsAwardsFooterComponents/FooterMenuLinks";
import { EVENTS_AWARDS_DTA_PATH } from "@events-awards/utils/constants";

/**
 * Component to display footer for desktop view in DTA pages
 */
const DTAFooterDesktop = (): React.ReactElement => {
  return (
    <div
      className="grid w-full grid-cols-12 text-center"
      data-testid="dta-footer-desktop-component"
    >
      <div className="col-span-2 col-start-2 pl-0 pr-3">
        <Link to={EVENTS_AWARDS_DTA_PATH} reloadDocument>
          <img
            src={logoFooterDTA}
            alt="DTA Awards logo"
            width={181}
            height={84}
            className="mb-6"
          />
        </Link>
      </div>

      <div className="col-span-4 pl-1 pr-3">
        <h3 className="mb-2 text-left font-poppins text-base font-semibold tracking-[1px]">
          About Us
        </h3>

        <div className="text-left leading-[1.4] text-white">
          <p>
            The Design AI and Tech Awards celebrates innovation across all types
            of enterprises — from startups and SMEs to large corporations — that
            harness design and technology to create impactful solutions for
            real-world business challenges.
          </p>

          <p>
            These awards are designed to recognise and celebrate innovation
            across various businesses sizes and industries.
          </p>
        </div>
      </div>

      <div className="col-span-3 px-3">
        <p className="mb-3 text-left font-semibold">Sections</p>

        <div className="my-2 flex flex-row">
          <FooterMenuLinks
            items={DTA_FOOTER_MENU.slice(0, 3)}
            className="space-y-4"
          />

          <FooterMenuLinks
            items={DTA_FOOTER_MENU.slice(3, 6)}
            className="space-y-4 pl-10"
          />
        </div>
      </div>

      <div className="col-span-2 pl-5 pr-3">
        <p className="mb-3 text-left font-semibold">Quick Links</p>

        <FooterMenuLinks
          items={DTA_FOOTER_MENU.slice(6, 9)}
          className="space-y-4"
        />
      </div>
    </div>
  );
};

export default DTAFooterDesktop;
